import { DataDogProvider } from "./DatadogProvider.web";
export default DataDogProvider;
